"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      auditDia: false,
      outPutDia: true,
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "名称/编码"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "报名人",
        prop: "displayName",
        isShow: true,
        width: "100"
      }, {
        name: "所属学校",
        prop: "userCode",
        isShow: true,
        width: "150"
      }, {
        name: "参赛项目",
        prop: "userCode",
        isShow: true,
        width: "150"
      }, {
        name: "项目组别",
        prop: "userCode",
        isShow: true,
        width: "150"
      }, {
        name: "参赛大类",
        prop: "userCode",
        isShow: true,
        width: "150"
      }, {
        name: "参赛人数",
        prop: "userCode",
        isShow: true,
        width: "150"
      }, {
        name: "指导教师",
        prop: "userCode",
        isShow: true,
        width: "150"
      }, {
        name: "创建时间",
        prop: "userCode",
        isShow: true,
        width: "150"
      }, {
        name: "状态",
        prop: "userCode",
        isShow: true,
        width: "150"
      }],
      funBtns: [{
        size: "small",
        click: "outPut",
        icon: "el-icon-upload",
        name: "导出",
        type: "primary"
      }, {
        size: "small",
        click: "auditApply",
        icon: "el-icon-circle-check",
        name: "审核",
        type: "primary"
      }, {
        size: "small",
        click: "Lock",
        icon: "el-icon-circle-close",
        name: "退回",
        type: "danger"
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      options: [{
        name: "审核进度",
        class: "edit",
        option: "modify",
        span: 3
      }],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      }
    };
  },
  methods: {
    // 审核报名表
    auditApply: function auditApply() {},
    // 审核进度
    auditProgress: function auditProgress() {},
    // 导出回执表
    outPut: function outPut() {
      this.outPutDia = true;
    },
    //
    listBureau: function listBureau() {},
    morePublishout: function morePublishout() {},
    morePublish: function morePublish() {},
    dels: function dels() {},
    // 新增
    saveBureau: function saveBureau() {
      this.$router.push("/test/school-add");
    },
    handleSelectionChange: function handleSelectionChange() {},
    deleteById: function deleteById() {},
    distribution: function distribution() {},
    viewAdmin: function viewAdmin() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange() {},
    handleSizeChange: function handleSizeChange() {}
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};